import {Fragment} from 'react';

interface Props {
  value?: string | any | null;
}
export function MixedText({value}: Props) {
  if (!value) {
    return null;
  }
  if (typeof value === 'string') {
    return <Fragment>{value}</Fragment>;
  }
  return <>{value}</>;
}
